import { useMemo } from 'react';

import { useDataProvider } from '@work4all/data';

import { LedgerAccount } from '@work4all/models/lib/Classes/LedgerAccount.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

interface IProps {
  number: number;
  id: number;
}

export const useExistingledgerAccounts = (props: IProps) => {
  const { id, number } = props;

  const existingLedgerAccountsReq = useMemo<DataRequest>(
    () => ({
      data: {
        id: null,
        number: null,
      } as LedgerAccount,
      entity: Entities.ledgerAccount,
      filter: [
        {
          id: {
            $ne: id,
          },
        },
        {
          number: {
            $eq: number,
          },
        },
      ],
    }),
    [number, id]
  );

  return useDataProvider<LedgerAccount>(existingLedgerAccountsReq);
};
